import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["id", "stroke", "fill"]
const _hoisted_3 = ["id", "stroke"]
const _hoisted_4 = ["id", "stroke"]
const _hoisted_5 = ["xlink:href", "values"]
const _hoisted_6 = ["xlink:href", "values"]
const _hoisted_7 = ["xlink:href"]
const _hoisted_8 = ["xlink:href", "values"]
const _hoisted_9 = ["xlink:href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    version: "1.1",
    id: _ctx.propId,
    viewBox: "0 0 100 100",
    onMouseenter: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.triggerAnimations && _ctx.triggerAnimations(...args))),
    onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.stopAnimations && _ctx.stopAnimations(...args)))
  }, [
    _createElementVNode("circle", {
      id: _ctx.propId + '-outline',
      cx: "50",
      cy: "50",
      r: "45",
      stroke: _ctx.svgStrokeColor,
      "stroke-dasharray": "360",
      "stroke-width": "5",
      fill: _ctx.svgFillColor
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      id: _ctx.propId + '-p1',
      d: "M30 30L70 70",
      stroke: _ctx.svgStrokeColor,
      style: {"stroke-width":"5"}
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      id: _ctx.propId + '-p2',
      d: "M70 30L30 70",
      stroke: _ctx.svgStrokeColor,
      style: {"stroke-width":"5"}
    }, null, 8, _hoisted_4),
    _createElementVNode("animate", {
      "xlink:href": '#' + _ctx.propId + '-outline',
      attributeType: "xml",
      attributeName: "fill",
      values: _ctx.svgFlipFill,
      class: "animate",
      begin: ""
    }, null, 8, _hoisted_5),
    _createElementVNode("animate", {
      "xlink:href": '#' + _ctx.propId + '-p1',
      attributeType: "xml",
      attributeName: "stroke",
      values: _ctx.svgFlipStroke,
      class: "animate",
      begin: ""
    }, null, 8, _hoisted_6),
    _createElementVNode("animate", {
      "xlink:href": '#' + _ctx.propId + '-p1',
      attributeType: "xml",
      attributeName: "d",
      from: "M30 30L30 30",
      to: "M30 30L70 70",
      dur: "0.25s",
      repeatCount: "0",
      class: "animate",
      begin: ""
    }, null, 8, _hoisted_7),
    _createElementVNode("animate", {
      "xlink:href": '#' + _ctx.propId + '-p2',
      attributeType: "xml",
      attributeName: "stroke",
      values: _ctx.svgFlipStroke,
      class: "animate",
      begin: ""
    }, null, 8, _hoisted_8),
    _createElementVNode("animate", {
      "xlink:href": '#' + _ctx.propId + '-p2',
      attributeType: "xml",
      attributeName: "d",
      from: "M70 30L70 30",
      to: "M30 70L70 30",
      dur: "0.25s",
      repeatCount: "0",
      class: "animate",
      begin: ""
    }, null, 8, _hoisted_9)
  ], 40, _hoisted_1))
}